import styled, { css, keyframes } from 'styled-components';
import { resolveCssValue } from '../../styles';
import { px } from '../../utils';
import { NON_BREAKING_SPACE } from '../constants';
import { createShouldForwardProp } from '../utils';
import { SkeletonVariant } from './Skeleton.constants';
import { HIGHLIGHT_STRIPE_WIDTH } from './Skeleton.styles.constants';
const skeletonKeyframes = keyframes(["0%{transform:translate3d(-100%,0,0);}100%{transform:translate3d(100%,0,0);}"]);
const SkeletonRoot = styled.span.withConfig({
  shouldForwardProp: createShouldForwardProp(['height', 'width'])
}).withConfig({
  componentId: "ds__sc-1x13yx-0"
})(["position:relative;display:block;width:", ";height:", ";overflow:hidden;transform:translateZ(0);", " background-color:", ";::before{content:", ";}::after{position:absolute;top:0;right:0;bottom:0;left:0;content:'';background-image:", ";animation:", " 1.2s ease-in-out infinite;@media (prefers-reduced-motion:reduce){animation:none;background-image:none;}}background-size:", " 100%;background-repeat:no-repeat;"], _ref => {
  let {
    width
  } = _ref;
  return width !== undefined ? resolveCssValue('width', width) : 'auto';
}, _ref2 => {
  let {
    height
  } = _ref2;
  return height !== undefined ? resolveCssValue('height', height) : 'auto';
}, _ref3 => {
  let {
    variant,
    height
  } = _ref3;
  if (variant === SkeletonVariant.TEXT) {
    return css(["height:", ";"], height !== undefined ? resolveCssValue('height', height) : '1.2em');
  }
  if (variant === SkeletonVariant.ROUND) {
    return css(["border-radius:50%;"]);
  }
}, _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.Skeleton.baseColor;
}, NON_BREAKING_SPACE, _ref5 => {
  let {
    theme
  } = _ref5;
  return `linear-gradient(90deg, ${theme.Skeleton.baseColor}, ${theme.Skeleton.highlightColor}, ${theme.Skeleton.baseColor})`;
}, skeletonKeyframes, px(HIGHLIGHT_STRIPE_WIDTH));
export { SkeletonRoot };